import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import WithToggle from "./withToggle";

export default function NearBids(props) {
    const renderItem = ({ firstBidPoint, lastBidPoint, id }, i) => (
        <div className="lh-14 pb-1" key={i}>
            <Link
                to={paths.bidShow("bid", id)}
                target="_blank"
                onClick={() => {
                    ymEvent("TripPlanningRouteDetailsUsed");
                    ymEvent("TripPlanningTableUsed");
                }}
            >
                {firstBidPoint.address} - {lastBidPoint.address}
            </Link>
            <br />
            <span className="small text-muted">
                {dateTimeToView(
                    firstBidPoint.enteredAtByLogistOrAuto ?? firstBidPoint.planEnterDateOffset,
                    "DD.MM.YYYY HH:mm (Z)",
                )}{" "}
                -{" "}
                {dateTimeToView(
                    lastBidPoint.leftAtByLogistOrAuto ??
                        lastBidPoint.enteredAtByLogistOrAuto ??
                        lastBidPoint.planLeaveDateOffset,
                    "DD.MM.YYYY HH:mm (Z)",
                )}
            </span>
        </div>
    );
    return (
        <WithToggle title={props.title}>
            <div className="p-expanded__inside-card mb-3">
                {props.data?.length === 0 ? <>&mdash;</> : props.data?.map(renderItem)}
            </div>
        </WithToggle>
    );
}
